import { render, staticRenderFns } from "./NswNewUserPass.vue?vue&type=template&id=1ce6a89c&scoped=true"
import script from "./NswNewUserPass.vue?vue&type=script&lang=js"
export * from "./NswNewUserPass.vue?vue&type=script&lang=js"
import style0 from "./NswNewUserPass.vue?vue&type=style&index=0&id=1ce6a89c&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce6a89c",
  null
  
)

export default component.exports